import {
  IFEStep1,
  IFEStep1Anio,
  IFEStep1Beneficiario,
  IFEStep2Dto,
} from "@models/*";
import { SPFEService } from "@services/proyecta/spfe.service";
import React, { Component } from "react";

export default class Example extends Component {
  private _exampleService: SPFEService;

  constructor(props?: any) {
    super(props);
    this._exampleService = new SPFEService();
    //this.getFE();
    this.saveFE();
  }

  private async getFE() {
    let data = await this._exampleService.getSPFE({
      budgetId: 379,
      subventionCodeId: 320,
    });
  }

  private async saveFE() {
    let genericInfo = {
      PFFRRLineaBase: 10,
      PPresCodSubvencionId: 320,
      PPresPresupuestoId: 260,
      PPresTotalAnio: 4242,
      Id: 71,
    } as IFEStep1;

    let baseLineYears: IFEStep1Anio[] = [
      { PPresAnioMeta: 2020, PProaAnioValue: 22222, Id: 146 },
      { PPresAnioMeta: 2021, PProaAnioValue: 33333, Id: 147 },
    ];

    let step2FE: IFEStep2Dto = {
      genericInfo: [
        {
          basicInfo: {
            PProaImplementadorTotal: 200,
            OCTAVIASLEPId: 200,
            PPresCodSubvencionId: 320,
            PPresPresupuestoId: 260,
            Id: 0,
          },
          implementerYears: [
            { PPresAnioMeta: 4242, PProaAnioValue: 4242, Id: 0 },
          ],
        },
      ],
    };
  }

  public render() {
    return <h3>Example</h3>;
  }
}
